import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function NextStepCard({ step, className, image }) {
  if (!step) return null;
  return (
    <div className={cn("relative overflow-hidden rounded-3xl border border-gold/40 bg-black text-white on-dark", className)} data-testid="next-step-card">
      {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
      <div className="relative p-7 sm:p-9 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div className="max-w-xl">
          <p className="eyebrow-label !text-gold mb-3">Recommended next step · {step.eyebrow}</p>
          <h3 className="font-display text-2xl sm:text-3xl leading-tight">{step.title}</h3>
          <p className="text-sm text-white/70 mt-2 leading-relaxed">{step.body}</p>
        </div>
        <Link to={step.route} className="btn-gold shrink-0" data-testid="next-step-cta">{step.cta}<ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  );
}
